import { ApiClient } from '../../../api/ApiClient';
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { stringStep } from '../../../concepts/commands/CommandWizard';
import { ObjectManager } from '../../../concepts/objects';
import { EditorSession } from '../../canvas/EditorSession';
import { ContentInjector } from '../../canvas/injection/ContentInjector';
import { PopupManager } from '../../popups/PopupManager';
import { importDataViaLanguageModelPopup } from './ImportDataViaLanguageModelPopup';
import { importDataViaLanguageModelPromptPopup } from './ImportDataViaLanguageModelPromptPopup';

class LangaugeModelStreamSink {

    private decoder = new TextDecoder('utf-8');
    private buffer = '';

    public push(value: Uint8Array) {

        const chunk = this.decoder.decode(value, { stream: true });
        // const chunks = JSON.parse(['[', chunk.replaceAll('}{', '},{'), ']'].join(''));

        // for (const ch of chunks) {
        //     const decodedText = Object.values(ch).map((code: any) => String.fromCharCode(code)).join('');
        //     const decoded = JSON.parse(decodedText);
        //     this.buffer += decoded.choices[0].delta.content;
        //     console.log(this.buffer);
        // }
    }
}

export const importDataViaLanguageModel = defineCommand(
    'importDataViaLanguageModel',
    'Import: Using AI...',
    async (cc, [container]: [any?]) => {

        const api = cc.resolve(ApiClient);

        const injector = cc.resolve(ContentInjector);
        const objects = cc.resolve(ObjectManager);
        const session = cc.resolve(EditorSession);
        const popups = cc.resolve(PopupManager);

        const p1 = await popups.invoke(importDataViaLanguageModelPopup());
        if (!p1.actioned || !p1.data || !(p1.data instanceof File)) return;

        const { url } = await api.upload('/files', p1.data as File);

        const p2 = await popups.invoke(importDataViaLanguageModelPromptPopup(url));
        const message = p2.data;

    },
    [
        stringStep('container', 'Container:')
    ]
);
